import React from "react";
import { GoLog } from "react-icons/go";
import { FiTrendingUp, FiTrendingDown } from "react-icons/fi";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";

const InfoCard = ({
  heading = "Pending Requests",
  number = 400,
  icon: Icon = GoLog,
  bottomText = "vs last week",
  trend = null, // Changed default to null
  bgColor = "from-orange-50 to-orange-300",
  iconColor = "text-yellow-400",
  buttonText = null,
  buttonLink = null,
  borderColor = "border-blue-500",
}) => {
  const navigate = useNavigate();

  // Only calculate trend-related variables if trend exists
  const trendIcon = trend?.isUp ? (
    <FiTrendingUp className="w-4 h-4 text-green-600" />
  ) : trend ? (
    <FiTrendingDown className="w-4 h-4 text-red-600" />
  ) : null;

  const trendTextColor = trend?.isUp ? "text-green-600" : "text-red-600";

  return (
    <div
      className={`relative rounded-lg border-l-4 ${borderColor} bg-gradient-to-r ${bgColor} p-4 sm:p-6 lg:p-8 overflow-hidden`}
    >
      {/* Circles Background */}
      <div className="absolute inset-0 z-0 sm:block hidden">
        <div className="absolute -top-32 right-6 w-60 h-60 bg-white opacity-20 rounded-full"></div>
        <div className="absolute -top-40 -right-32 w-80 h-72 bg-white opacity-20 rounded-full"></div>
      </div>

      <div className="flex flex-wrap items-start sm:items-center gap-4 sm:gap-6 z-10 relative">
        {/* Icon */}
        <div className="flex-shrink-0">
          {typeof Icon === "string" ? (
            <img
              src={Icon}
              alt=""
              className="h-10 w-10 object-contain text-yellow-400"
            />
          ) : (
            <Icon className={`h-10 w-10 ${iconColor}`} />
          )}
        </div>

        {/* Content */}
        <div className="flex-grow min-w-0">
          <div className="text-sm sm:text-base text-[#111827]">{heading}</div>
          <div className="flex items-baseline space-x-2 flex-wrap">
            <div className="text-2xl sm:text-3xl text-[#111827]">{number}</div>
            {trend && (
              <div
                className={`text-sm font-bold flex items-baseline space-x-1 ${trendTextColor}`}
              >
                {trendIcon}
                <span>{trend.percentage}</span>
                <span className="text-sm text-[#6B7280] font-semibold">
                  {bottomText}
                </span>
              </div>
            )}
          </div>
        </div>

        {/* Button (conditionally rendered) */}
        {buttonText && buttonLink && (
          <div className="flex-shrink-0 w-full sm:w-auto">
            <Button
              onClick={() => navigate(buttonLink)}
              className="w-full sm:w-auto px-4 py-2 bg-[#14B8A6] text-sm sm:text-base text-white rounded hover:bg-[#2DD4BF]"
            >
              {buttonText}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoCard;
